import { Giustificativo } from "@/api/openapi";
import { AttendancesContext, PspContext } from "@/config/contexts";
import { TempAttendance } from "@/config/types";
import { parseHours } from "@/screens/app/attendances/attendanceUtils";
import { useContext } from "react";

type UseAttendanceDesktopGiustificativoRowParams = {
  employeeAttendance: TempAttendance;
  giustificativo: Giustificativo;
};

export function useAttendanceDesktopGiustificativoRow({
  employeeAttendance,
  giustificativo,
}: UseAttendanceDesktopGiustificativoRowParams) {
  const { lang } = useContext(PspContext);
  const { setTempAttendanceMonth, isSubmitted } =
    useContext(AttendancesContext);

  const giustificativoSum = employeeAttendance.days.reduce((sum, day) => {
    const matchingGiustificativo = day.giustificativi.find(
      (g) => g.type === giustificativo.type,
    );

    return sum + parseHours(matchingGiustificativo?.hours ?? "");
  }, 0);

  return { giustificativoSum, setTempAttendanceMonth, isSubmitted, lang };
}
